import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { constants } from "../../../utils/constants";
import { AuthService } from "../../../services/auth.service";
import { IRequestType } from "../../../models/request.model";
import { RequestService } from "../../../services/request.service";
import { IErrorAlert } from "../../../interfaces/error.interface";
import { delay } from "rxjs/operators";

@Component({
  selector: "app-request-search",
  templateUrl: "./request-search.component.html",
  styleUrls: ["./request-search.component.css", "../../pages.component.css"],
})
export class RequestSearchComponent implements OnInit {
  constants: any = constants;
  states: any[] = constants.rules.requestStates;
  requestTypes: any[] = constants.rules.requestTypes;

  error: IErrorAlert;
  sent = false;
  disabled = true;
  loading: boolean;

  form: FormGroup;

  constructor(
    public _auth: AuthService,
    public _request: RequestService,
    private _fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.reset();
  }

  search() {
    this.loading = true;
    this.sent = true;
    this.error = null;
    const data = {
      ruc: this._auth.user.getUserData().idNumber,
      limit: 300,
      number: this.form.value.number,
      typeCode: this.getNumberOf(this.form.value.type),
      stateCode: this.getNumberOf(this.form.value.state),
      date: this.getDateInStringFormat(),
    };
    this._request.searchRequests(data).subscribe((resp) => (
             
              this.loading = false
      
            
        ),
      (err: IErrorAlert) => {
        
        this.error = err;
        this.loading = false;
      }
    );
    
  

  }

  getNumberOf(value: any) {
    return !value ? null : parseInt(value);
  }

  getDateInStringFormat() {
    const date = this.form.value.date;
    if (date === "" || date.getTime() === 0) return null;

    const month = date.getMonth() + 1;

    const dateString = `${date
      .getDate()
      .toString()
      .padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;

    return dateString;
  }

  reset() {
    this.initForm();
    this.error = null;
    this._request.resetSearch();
  }

  initForm() {
    this.form = this._fb.group({
      number: "",
      type: "",
      date: "",
      state: "",
    });
    this.form.valueChanges
      .pipe(delay(0)) //fixing unchecked error
      .subscribe((data) => {
        this.disabled =
          data.number === "" &&
          data.type === "" &&
          this.form.get("date").pristine &&
          data.state === "";
      });
  }
}
